import React from 'react';
import PremiumLockPage from './PremiumLockPage';

const SubscriptionRoute = ({ user, children, navigate }) => {
    // Check if user has explicit 'isPremium' flag (legacy) OR valid subscription status
    const isLegacyPremium = user?.isPremium === true;

    // New License System Check
    const status = user?.subscriptionStatus; // 'trial', 'active', 'expired'
    const endDate = user?.subscriptionEndDate?.toDate ? user.subscriptionEndDate.toDate() : null;
    const isNotExpired = endDate ? endDate > new Date() : false;

    const hasValidLicense = (status === 'active' || status === 'trial') && isNotExpired;

    // Access granted if legacy premium OR valid license
    if (isLegacyPremium || hasValidLicense) {
        return children;
    }

    return <PremiumLockPage onUpgrade={() => {
        if (navigate) {
            navigate('pricing');
        } else {
            window.location.hash = '#pricing';
        }
    }} />;
};

export default SubscriptionRoute;
